import { render, staticRenderFns } from "./message-input-button.vue?vue&type=template&id=53ec671e&scoped=true"
import script from "./message-input-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-button.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-input-button.vue?vue&type=style&index=0&id=53ec671e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec671e",
  null
  
)

export default component.exports